/**
 * FIXME: ideally included in vite.config.ts
 * see note there regarding @vitejs/plugin-legacy
 */

if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

if (!Array.prototype.toSpliced) {
  Array.prototype.toSpliced = function (...args) {
    const copy = this.slice();
    copy.splice(...args);
    return copy;
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    if (this == null)
      throw new TypeError("Array.prototype.at called on null or undefined");

    const obj = Object(this);
    const length = obj.length >>> 0;

    const realIndex = index < 0 ? length + index : index;

    if (realIndex < 0 || realIndex >= length) return undefined;

    return obj[realIndex];
  };
}

if (!Set.prototype.symmetricDifference) {
  Set.prototype.symmetricDifference = function (otherSet) {
    if (!(otherSet instanceof Set))
      throw new TypeError("Argument must be a Set");

    const result = new Set();

    for (const item of this) if (!otherSet.has(item)) result.add(item);

    for (const item of otherSet) if (!this.has(item)) result.add(item);

    return result;
  };
}
